<template lang="pug">
  v-container(fluid data-test="course-leaders")
    portal(to='toolbar')
      v-toolbar-title Course Leaders
      
    v-card
      courseLeadersList(
        :list="list"
        :loading="loading"
        @reload-list="loadList"
      )
  
</template>

<script>
import errorsMixin from '@/mixins/errors.mixin'
import Svc from "./core/courseLeadersService"

export default {
  mixins: [errorsMixin],

  data: () => ({
    svc: new Svc(),
    loading: false,
    list: []
  }),

  provide: function() {
    return {
      svc: this.svc
    }
  },
  
  mounted() {
    this.loadList();
  },
  
  methods: {
    async loadList() {
      try {
        this.loading = true;
        let { results } = await this.svc.list(this.$route.query);
        this.list = results.sort((a, b) => (a.ID > b.ID) ? 1 : -1);
        this.loading = false
      } catch (error) {
        this.loading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

  },

  components: {
    courseLeadersList: () => import('./components/courseLeadersList.vue'),
  },
} 
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_placeholder.scss";
@import "@/assets/scss/_table_spread";
</style>
